import { __values } from "tslib";
/**
 * @public
 */
export function getPosition(position) {
    if (typeof position === 'string') {
        return position;
    }
    if (typeof position === 'function') {
        return position();
    }
    return undefined;
}
/**
 * @public
 */
export function getStepPosition(step) {
    return step ? {
        left: getPosition(step.left),
        right: getPosition(step.right),
        top: getPosition(step.top),
        bottom: getPosition(step.bottom)
    } : {};
}
/**
 * @public
 */
export function highlight(step) {
    if (step.targetElementId) {
        var target = document.getElementById(step.targetElementId);
        if (target) {
            target.classList.add('tour-highlight');
        }
    }
}
/**
 * @public
 */
export function unhighlight(steps) {
    var e_1, _a;
    try {
        for (var steps_1 = __values(steps), steps_1_1 = steps_1.next(); !steps_1_1.done; steps_1_1 = steps_1.next()) {
            var step = steps_1_1.value;
            if (step.targetElementId) {
                var target = document.getElementById(step.targetElementId);
                if (target) {
                    target.classList.remove('tour-highlight');
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (steps_1_1 && !steps_1_1.done && (_a = steps_1.return)) _a.call(steps_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
